// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___4vzcE","innerTop":"style__innerTop___2zZd2","innerBottom":"style__innerBottom___2MvHI","centerLabel":"style__centerLabel___3yptx","formContainer":"style__formContainer___3mYwH","form":"style__form___1op7A","submitBtnWrap":"style__submitBtnWrap___2mKcR","bottomRow":"style__bottomRow___2xcdA","greeting":"style__greeting___3maZ7","authToggler":"style__authToggler___wBa8K","authTogglerLinkActive":"style__authTogglerLinkActive___aRkSR","authTogglerLink":"style__authTogglerLink___1eEgL"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/ui/screens/registration/style.css
// module id = 1046
// module chunks = 0